export { default } from './TrendTopicFilter';
